import React, { useState } from 'react';

import { Modal } from 'react-bootstrap';

import Button from '../../../../common/components/Button/Button';

import SchemesExportForm from './SchemesExportForm';
import './SchemesExportModal.scss';

const SchemesExportModal = ({ schemes, isSchemeGroup, productId }) => {
  const [show, setShow] = useState(false);

  const openModal = () => {
    setShow(true);
  };

  const closeModal = () => {
    setShow(false);
  };

  const hasActiveSchemes = schemes?.length;
  return (
    <>
      {!!hasActiveSchemes && (
        <Button
          bsStyle="primary"
          className="pull-right pad-right"
          handleClick={openModal}
          label="Export Schemes"
        />
      )}

      <Modal show={show} onHide={closeModal} onComplete={closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Export Scheme</Modal.Title>
        </Modal.Header>
        {show && (
          <SchemesExportForm
            schemes={schemes}
            isSchemeGroup={isSchemeGroup}
            productId={productId}
            onComplete={closeModal}
          />
        )}
      </Modal>
    </>
  );
};

export default SchemesExportModal;
